// src/components/Login.jsx
import React, { useEffect, useRef } from "react";
import "./Login.css";
import { useLogin } from "../LoginProvider";

export default function Login({ isOpen, onClose, onSwitch }) {
  const dialogRef = useRef(null);
  const { loginEmail, loading, error, setError } = useLogin();

  useEffect(() => {
    if (!isOpen) return;
    const firstInput = dialogRef.current?.querySelector("input");
    firstInput?.focus();
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   const data = new FormData(e.currentTarget);
  //   const email = data.get("email");
  //   const password = data.get("password");

  //   const user = await loginEmail({ email, password });
  //   if (user) onClose?.();
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  const data = new FormData(e.currentTarget);
  const email = data.get("email");
  const password = data.get("password");

  // Authentifie l'utilisateur
  const user = await loginEmail({ email, password });

  if (user) {
    // Ferme la modale ou popup
    onClose?.();

    // 🟢 Envoi d'une notification WhatsApp
    //const message = `👤 *${user.name}* vient de se connecter.`;

    try {
      // await fetch("/api/send-whatsapp", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({
      //     to: "+22890045926",
      //     text: message,
      //   }),
      // });
      //console.log("✅ Notification WhatsApp envoyée !");
    } catch (err) {
      //console.error("Erreur envoi WhatsApp :", err);
    }
  } else {
    setError("Email ou mot de passe incorrect.");
  }
};


  return (
    <div className="modal-overlay" onClick={onClose} aria-modal="true" role="dialog">
      <div className="modal" onClick={(e) => e.stopPropagation()} ref={dialogRef}>
        <button className="modal-close" aria-label="Fermer" onClick={onClose}>×</button>

        <img src="/images/dollarstore.jpg" alt="Dollar Store" className="logo-img-login" />
        <h2 className="modal-title">Connexion</h2>

        <form className="form" onSubmit={handleSubmit}>
          <label className="field">
            <span>E-mail</span>
            <input type="email" name="email" placeholder="vous@exemple.com" required />
          </label>

          <label className="field">
            <span>Mot de passe</span>
            <input type="password" name="password" placeholder="Votre mot de passe" required minLength={6} />
          </label>

           
       <p className="switch">
          Mot de passe oublié?{" "}
          <button className="link" type="button" onClick={() => {setError("") ; onSwitch("forgot")}}>
            Cliquez ici.
          </button>
        </p>
          <button className="submit" type="submit" disabled={loading}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>

          {error && (
            <div style={{ color: "#dc2626", marginTop: 8, fontSize: 14 }}>
              {error}
            </div>
          )}
        </form>

        <p className="switch">
          Pas de compte ?{" "}
          <button className="link" type="button" onClick={() => onSwitch?.("register")}>
            Créer un compte
          </button>
        </p>
      </div>
    </div>
  );
}
